import store from '../store';
import * as commitTypes from '../store/commitTypes';
import Cookies from 'js-cookie';

const getState = () => {
    const jsonState = localStorage.getItem('bm_state');
    return !!jsonState ? JSON.parse(jsonState): null;
}

export const loginGuard = (to, from, next) => {
    const state = getState();
    const user = !!state && !!state.user? state.user: null;

    if(!!user) {
        store.commit(commitTypes.SET_USER, user);
    }


    if(store.getters.authenticated) return next();
    next({ name: 'login' });
};

export const updateGuard = async (to, from, next) => {

        if(to.name !== 'home') return next();

        const version = await store.dispatch('VALIDATE_VERSION');

        const currentVersion = Cookies.get('bitacorapp_app_version');
        if(!currentVersion) {
            Cookies.set('bitacorapp_app_version', version, { expires: 365 });
            Cookies.set('bitacorapp_update_required', 1, { expires: 365 });
            // store.commit('SET_REQUIRE_UPDATE', true);
        } else {
            
            if(currentVersion !== version) {
                // store.commit('SET_REQUIRE_UPDATE', true);
                Cookies.set('bitacorapp_app_version', version, { expires: 365 });
                Cookies.set('bitacorapp_update_required', 1, { expires: 365 });
            } else {
                // store.commit('SET_REQUIRE_UPDATE', false);
                Cookies.remove('bitacorapp_update_required');
            }
        }

        next();
}


// WEBPACK FOOTER //
// ./src/router/guards.js